var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellcontract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#DAB9E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3928_3091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0056 23.3177L37.7153 14.0003C37.0426 13.3257 36.1484 12.9526 35.1988 12.9526H18.375C16.4125 12.9526 14.814 14.5558 14.814 16.5241V47.4764C14.814 49.4447 16.4125 51.0479 18.375 51.0479H44.4891C46.4516 51.0479 48.0501 49.4447 48.0501 47.4764V25.8415C48.0501 24.8891 47.6782 23.9923 47.0056 23.3177ZM45.1855 24.8574H37.3671C36.7103 24.8574 36.1801 24.3257 36.1801 23.6669V15.8257L45.1855 24.8574ZM44.4891 48.6669H18.375C17.7182 48.6669 17.188 48.1352 17.188 47.4764V16.5241C17.188 15.8653 17.7182 15.3336 18.375 15.3336H33.8061V23.6669C33.8061 25.6352 35.4046 27.2384 37.3671 27.2384H45.6761V47.4764C45.6761 48.1352 45.1459 48.6669 44.4891 48.6669Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9282 37.8652H31.4321C30.7753 37.8652 30.2451 38.397 30.2451 39.0557C30.2451 39.7144 30.7753 40.2462 31.4321 40.2462H40.9282C41.585 40.2462 42.1152 39.7144 42.1152 39.0557C42.1152 38.397 41.585 37.8652 40.9282 37.8652Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9281 42.7144H23.123C22.4662 42.7144 21.936 43.2461 21.936 43.9048C21.936 44.5636 22.4662 45.0953 23.123 45.0953H40.9281C41.5849 45.0953 42.1151 44.5636 42.1151 43.9048C42.1151 43.2461 41.5849 42.7144 40.9281 42.7144Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7989 35.762C31.4557 35.762 31.9859 35.2303 31.9859 34.5715C31.9859 33.9128 31.4557 33.3811 30.7989 33.3811C28.1004 33.3811 25.766 31.762 24.7135 29.4445H26.5969C27.2537 29.4445 27.7839 28.9128 27.7839 28.2541C27.7839 27.5953 27.2537 27.0636 26.5969 27.0636H24.1279C24.1279 26.9366 24.1121 26.8096 24.1121 26.6747C24.1121 26.5398 24.1279 26.4128 24.1279 26.2858H28.6939C29.3507 26.2858 29.8809 25.7541 29.8809 25.0953C29.8809 24.4366 29.3507 23.9049 28.6939 23.9049H24.7135C25.766 21.5874 28.0925 19.9684 30.7989 19.9684C31.4557 19.9684 31.9859 19.4366 31.9859 18.7779C31.9859 18.1191 31.4557 17.5874 30.7989 17.5874C26.7631 17.5874 23.3445 20.2461 22.1733 23.9049H20.2978C19.641 23.9049 19.1108 24.4366 19.1108 25.0953C19.1108 25.7541 19.641 26.2858 20.2978 26.2858H21.7539C21.7539 26.4128 21.7381 26.5398 21.7381 26.6747C21.7381 26.8096 21.7539 26.9366 21.7539 27.0636H20.2978C19.641 27.0636 19.1108 27.5953 19.1108 28.2541C19.1108 28.9128 19.641 29.4445 20.2978 29.4445H22.1733C23.3445 33.1033 26.771 35.762 30.7989 35.762Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3928_3091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.2362,
    height: 38.0952,
    fill: "white",
    transform: "translate(14.814 12.9526)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellcontract);
export default __webpack_public_path__ + "static/media/sellcontract.392a4ef8418aaacb016ac4acf4436a0a.svg";
export { ForwardRef as ReactComponent };